import {PaymentsRepository} from './PaymentsRepository';
import {paymentsAPI} from '../api/paymentsAPI';
import {Payment} from '../models/Payment';
import {PaymentFilterParams} from '../models/Payment';
import {PaymentStatistics} from '../models/Payment';
import {mapPaymentDTOToModel} from '../mappers/payment.mapper';
import {AppError, ErrorType} from '../../../Data/config/AppError';

export class PaymentsRepositoryImpl implements PaymentsRepository {
  async getAllPayments (): Promise<Payment[]> {
    try {
      const response = await paymentsAPI.getAllPayments();
      const result = (response || []).map(mapPaymentDTOToModel);
      return result;
    } catch (error) {
      if (error instanceof AppError) {
        throw error;
      }
      throw new AppError(
        'حدث خطأ أثناء جلب المدفوعات',
        ErrorType.UNKNOWN,
        undefined,
        undefined,
        error
      );
    }
  }

  async getPaymentsWithFilters (params: PaymentFilterParams): Promise<{ items: Payment[]; pagination?: any }> {
    try {
      const response = await paymentsAPI.getPaymentsWithFilters(params);
      const result = (response.items || []).map(mapPaymentDTOToModel);

      return {
        items: result,
        pagination: response.pagination
      };
    } catch (error) {
      if (error instanceof AppError) {
        throw error;
      }
      throw new AppError(
        'حدث خطأ أثناء جلب المدفوعات',
        ErrorType.UNKNOWN,
        undefined,
        undefined,
        error
      );
    }
  }


  async getStatistics (): Promise<PaymentStatistics> {
    try {
      const response = await paymentsAPI.getStatistics();
      return response;
    } catch (error) {
      if (error instanceof AppError) {
        throw error;
      }
      throw new AppError(
        'حدث خطأ أثناء جلب إحصائيات المدفوعات',
        ErrorType.UNKNOWN,
        undefined,
        undefined,
        error
      );
    }
  }
}
